var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-wrapper"},[_c('sidebar',{staticClass:"sidebar-container"}),_c('app-main',{staticClass:"app-main",class:_vm.padClass}),_c('wms-portal-target',{attrs:{"name":"app-page-portal-target"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }